<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md class="subnav__semi-reduced-padding">
    <sbnb-back-button
      style="margin-bottom: 24px"
      [routerLink]="['/direct']"
      [disableRedirect]="true"></sbnb-back-button>

    <ng-template [ngTemplateOutlet]="navTemplate"></ng-template>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs class="!mb-0 block sbnbDesktop:hidden"></sbnb-page-header>
    </app-feature-flag-tabs>
    <ng-container *ngIf="site?.uuid; else loadingSiteTemplate">
      <ng-container *ngIf="activeNavItem.id !== 'search-widget'">
        <div fxLayout fxLayoutAlign="start center" fxLayoutGap="12px" style="margin-bottom: 30px">
          <h2 fxFlex class="nomargin">
            {{ activeNavItem.label === 'Settings' ? 'Custom Site' : activeNavItem.label }}
          </h2>
          <sbnb-button size="mini" (click)="save()" [loading]="saving">Save</sbnb-button>
        </div>
      </ng-container>

      <div [ngSwitch]="activeNavItem.id" [class.content-container]="activeNavItem.id !== 'search-widget'">
        <ng-template *ngSwitchCase="'properties'" [ngTemplateOutlet]="propertiesTemplate"></ng-template>
        <ng-template *ngSwitchCase="'styling'" [ngTemplateOutlet]="stylingTemplate"></ng-template>
        <ng-template *ngSwitchCase="'search-widget'" [ngTemplateOutlet]="searchWidgetTemplate"></ng-template>
      </div>
    </ng-container>

    <ng-template #loadingSiteTemplate>
      <mat-spinner [diameter]="24"></mat-spinner>
    </ng-template>
  </main>
</div>

<sbnb-mobile-sidebar [title]="'Site Edit'">
  <sbnb-back-button style="margin-bottom: 24px" [routerLink]="['/direct']" [disableRedirect]="true"></sbnb-back-button>
  <ng-template [ngTemplateOutlet]="navTemplate"></ng-template>
</sbnb-mobile-sidebar>

<ng-template #navTemplate>
  <h4
    *ngFor="let nav of navItems"
    [class.raspberry-darker]="activeNavItem === nav"
    fxLayout
    fxLayoutAlign="start center"
    fxLayoutGap="10px"
    (click)="activeNavItem = nav">
    <mat-icon [class.raspberry-darker]="activeNavItem === nav">{{ nav.icon }}</mat-icon>
    <span fxFlex>{{ nav.label }}</span>
  </h4>
</ng-template>

<ng-template #propertiesTemplate>
  <sbnb-helptext-wrapper
    class="helptext-wrapper-type-content"
    [area]="'content'"
    [pageId]="'direct-custom-site-edit-properties'"></sbnb-helptext-wrapper>

  <div class="enable-widgets" fxLayout="column" fxLayoutGap="6px">
    <mat-slide-toggle class="nopadding" [(ngModel)]="site.widgets_enabled">
      <strong>Enable widgets</strong>
    </mat-slide-toggle>
    <span class="text__small night-lighter">
      You'll need to enable your widget before you can use it to take Direct bookings. Disable this to temporarily
      prevent bookings from being taken.
    </span>
  </div>

  <div *ngIf="properties$ | async as properties; else loadingProperties">
    <sbnb-direct-properties-selection
      *ngIf="properties.length > 0"
      [mode]="'widget'"
      [allPropertiesEnabled]="true"
      [widget]="site"
      [properties]="properties"
      [futureProperties]="false"
      [selectedProperties]="site.property_ids"
      [propertyUrls]="site.properties"
      [reorderEnabled]="false"
      (propertiesChange)="propertiesChange($event)"></sbnb-direct-properties-selection>
  </div>

  <ng-template #loadingProperties>
    <mat-spinner [diameter]="24"></mat-spinner>
  </ng-template>

  <div style="margin-top: 36px" fxLayout fxLayoutAlign="space-between center">
    <div class="flex-1 flex items-center gap-1.5">
      <sbnb-button
        class="delete"
        [label]="deleting ? 'Deleting...' : 'Delete'"
        icon="trash"
        type="secondary-danger"
        size="mini"
        [loading]="deleting"
        (clicked)="deleteCustomSitePrompt()"></sbnb-button>
    </div>
  </div>
</ng-template>

<ng-template #stylingTemplate>
  <sbnb-helptext-wrapper
    class="helptext-wrapper-type-content"
    [area]="'content'"
    [pageId]="'direct-custom-site-edit-styling'"></sbnb-helptext-wrapper>

  <div fxLayout fxLayoutGap="80px">
    <div fxFlex class="direct-custom-site-styling" fxLayout="column" fxLayoutGap="12px">
      <div *ngIf="templates" fxLayout="column" fxLayoutGap="6px">
        <strong>Theme</strong>

        <mat-form-field class="fw nopadding">
          <mat-select [(ngModel)]="site.theme" (ngModelChange)="themeUpdated()" placeholder="Custom">
            <mat-option *ngFor="let template of templates" [value]="template.slug">{{ template.name }}</mat-option>
            <mat-option [value]="null">Custom</mat-option>
          </mat-select>
        </mat-form-field>

        <span class="card__collapsed-helper-text">
          Changing the theme will visually change the booking and propety search widgets.
        </span>
      </div>

      <ng-container *ngIf="site.theme === null">
        <div class="primary-color">
          <label>Primary color</label>
          <div fxLayout fxLayoutGap="12px">
            <div
              style="
                width: 40px;
                height: 40px;
                border-radius: 4px;
                position: relative;
                top: 6px;
                border: 1px solid #ccc;
              "
              [style.background]="site.styles.primary_color || '#fff'"></div>
            <mat-form-field fxFlex class="fw nopadding">
              <input
                matInput
                placeholder="#000000"
                [(ngModel)]="site.styles.primary_color"
                (ngModelChange)="refreshPreview()" />
            </mat-form-field>
          </div>
        </div>

        <div class="secondary-color">
          <label>Secondary color</label>
          <div fxLayout fxLayoutGap="12px">
            <div
              style="
                width: 40px;
                height: 40px;
                border-radius: 4px;
                position: relative;
                top: 6px;
                border: 1px solid #ccc;
              "
              [style.background]="site.styles.secondary_color || '#fff'"></div>
            <mat-form-field fxFlex class="fw nopadding">
              <input
                matInput
                placeholder="#333333"
                [(ngModel)]="site.styles.secondary_color"
                (ngModelChange)="refreshPreview()" />
            </mat-form-field>
          </div>
        </div>

        <div class="tertiary-color">
          <label>Tertiary color</label>
          <div fxLayout fxLayoutGap="12px">
            <div
              style="
                width: 40px;
                height: 40px;
                border-radius: 4px;
                position: relative;
                top: 6px;
                border: 1px solid #ccc;
              "
              [style.background]="site.styles.tertiary_color || '#fff'"></div>
            <mat-form-field fxFlex class="fw nopadding">
              <input
                matInput
                placeholder="#666666"
                [(ngModel)]="site.styles.tertiary_color"
                (ngModelChange)="refreshPreview()" />
            </mat-form-field>
          </div>
        </div>
      </ng-container>
    </div>

    <div *ngIf="properties$ | async as properties" fxFlex="320px" fxHide.lt-md class="direct-widget-preview">
      <h3 style="margin-bottom: 20px">Booking Widget Preview</h3>

      <div fxLayout="column" fxLayoutGap="6px">
        <strong class="text__small">Property</strong>
        <mat-form-field>
          <mat-select [(ngModel)]="previewPropertyId" (ngModelChange)="refreshPreview()">
            <mat-option *ngFor="let property of properties" [value]="property.id">{{ property.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <iframe
        *ngIf="previewPropertyId"
        sandbox="allow-scripts allow-same-origin"
        style="width: 320px; height: 800px"
        frameborder="0"
        [src]="widgetPreviewSrcUrl"></iframe>
    </div>
  </div>
</ng-template>

<ng-template #searchWidgetTemplate>
  <sbnb-direct-edit-mps-widget parentType="custom" [parentId]="site.uuid"></sbnb-direct-edit-mps-widget>
</ng-template>
